"use client";

import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { SplitText } from "gsap/all";

const MessageSection = () => {
  useGSAP(() => {
    const firstMsgSplit = SplitText.create(".first-message", {
      type: "words",
    });
    const secMsgSplit = SplitText.create(".second-message", {
      type: "words",
    });
    const paragraphSplit = SplitText.create(".message-content p", {
      type: "words, lines",
      linesClass: "paragraph-line",
    });

    const mm = gsap.matchMedia();

    mm.add(
      {
        isMobile: "(max-width: 768px)",
        isDesktop: "(min-width: 769px)",
      },
      (context) => {
        const { isMobile } = context.conditions as {
          isMobile: boolean;
          isDesktop: boolean;
        };

        gsap.to(firstMsgSplit.words, {
          color: "#F9EADE",
          ease: "power1.in",
          stagger: 0.1,
          scrollTrigger: {
            trigger: ".first-message",
            start: isMobile ? "top 90%" : "top 80%",
            end: "bottom 50%",
            scrub: true,
          },
        });

        gsap.to(secMsgSplit.words, {
          color: "#F9EADE",
          ease: "power1.in",
          stagger: 0.1,
          scrollTrigger: {
            trigger: ".second-message",
            start: isMobile ? "top 90%" : "top 80%",
            end: "bottom 50%",
            scrub: true,
          },
        });

        const revealTl = gsap.timeline({
          scrollTrigger: {
            trigger: ".msg-text-scroll",
            start: "top 65%",
            toggleActions: "play none none reverse",
          },
        });
        revealTl.to(".msg-text-scroll", {
          duration: 1,
          clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
          ease: "circ.inOut",
        });

        gsap.to(paragraphSplit.words, {
          color: "#ffffff",
          ease: "power1.in",
          stagger: 0.1,
          scrollTrigger: {
            trigger: ".message-content p",
            start: "top 90%",
            end: "bottom 70%",
            scrub: true,
          },
        });
      }
    );

    return () => {
      mm.revert();
      firstMsgSplit.revert();
      secMsgSplit.revert();
      paragraphSplit.revert();
    };
  });

  return (
    <section id="our-story" className="message-content">
      <div className="container mx-auto flex-center py-28 relative">
        <div className="w-full h-full">
          <div className="msg-wrapper px-4 gap-2 md:gap-0">
            <h1 className="first-message relative z-10 text-[54px] md:text-[100.448px] md:leading-[100.08px] leading-[58px] tracking-[-0.04em] md:tracking-normal">
              Experience India’s trending flavours,
            </h1>

            <div
              style={{
                clipPath: "polygon(0 0, 0 0, 0 100%, 0% 100%)",
              }}
              className="msg-text-scroll relative z-20 inline-flex w-fit justify-center transform rotate-3 -mt-2 md:-mt-3 -mb-4 md:-mb-3"
            >
              <div className="bg-[#E3A458] border-4 border-[#7F3B2D] md:border-transparent md:border-0  md:pb-8 pb-2 pt-2 px-4 md:px-5 md:py-6 flex items-center justify-center">
                <h2 className="text-[#7F3B2D] md:text-[5.7rem] my-auto text-[54px] leading-[58px] tracking-[-0.04em] md:tracking-normal font-bold text-center whitespace-nowrap">
                  JUST HITS DIFFERENT
                </h2>
              </div>
            </div>

            <h1 className="second-message text-center md:mt-0 relative z-10 text-[54px] leading-[58px] tracking-[-0.04em] md:text-[100.448px] md:leading-[100.08px] md:tracking-normal">
              married with the legendary <br className="hidden md:block" /> Middle Eastern Kunafas
            </h1>
            <h1 className="second-message md:mt-0 relative z-10 text-[54px] leading-[58px] tracking-[-0.04em] md:text-[100.448px] md:leading-[100.08px] md:tracking-normal">
              OMG! Taste that Slaps!!
            </h1>
          </div>

          <div className="flex-center md:mt-20 mt-16">
            <div className="max-w-md px-6 md:px-10 flex-center overflow-hidden">
              {/* <p className="text-center text-sm md:text-base">
                Indulge at Kunafa World — crispy kataifi, creamy layers, and
                fragrant syrup in every bite. One slice, pure nostalgia.
              </p> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MessageSection;
